import { render, staticRenderFns } from "./_form.content-blocks.page.vue?vue&type=template&id=a0fc9498&"
import script from "./_form.content-blocks.page.vue?vue&type=script&lang=js&"
export * from "./_form.content-blocks.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
